<template>
  <v-container>
    <p>Settings Page</p>

    <p>This should be a protected area for user {{ user.email }}</p>

  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      breadcrumbs: [
        { text: 'Dashboard', disabled: false, link: '/dashboard' },
        { text: 'Profile', disabled: true }
      ]
    }
  },
  mounted () {
    this.loadBreadcrumbs(this.breadcrumbs)
    this.loadCurNav(this.navMenu)
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  methods: {
    ...mapActions({
      loadBreadcrumbs: 'nav/loadBreadcrumbs',
      loadCurNav: 'nav/loadCurNav'
    })
  }

}
</script>

<style scoped>

</style>
